import { Card } from "@/components/ui/card";
import { Pencil, Palette, BarChart, ShoppingBag, GraduationCap, Image } from "lucide-react";

const useCases = [
  {
    icon: Pencil,
    title: "Content Creators & Bloggers",
    description: "Enhance your content's accessibility and SEO rankings with accurate image descriptions that help reach a wider audience."
  },
  {
    icon: Palette,
    title: "Graphic Designers & Photographers",
    description: "Showcase your visual work effectively with AI-generated descriptions that help clients and viewers understand your creative vision."
  },
  {
    icon: BarChart,
    title: "Digital Marketers",
    description: "Boost your SEO performance with keyword-rich alt texts that improve search visibility and drive more traffic."
  },
  {
    icon: ShoppingBag,
    title: "E-commerce Businesses",
    description: "Create detailed product image descriptions that improve accessibility and help drive more sales."
  },
  {
    icon: GraduationCap,
    title: "Educational Institutions",
    description: "Make learning materials accessible to all students with accurate descriptions for diagrams and educational content."
  },
  {
    icon: Image,
    title: "Visual Content Creators",
    description: "Ensure your visual work is accessible and discoverable with detailed, accurate image descriptions."
  }
];

export const UseCases = () => {
  return (
    <section className="py-20 bg-sage-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-4 text-sage-800">
          Who Can Benefit?
        </h2>
        <p className="text-sage-600 text-center mb-12 max-w-2xl mx-auto">
          Our AI Alt Text Generator is designed to serve diverse needs across various industries and professions
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {useCases.map((useCase, index) => (
            <Card key={index} className="p-6 hover-scale glass-card">
              <div className="h-12 w-12 rounded-lg bg-sage-100 flex items-center justify-center text-sage-600 mb-4">
                <useCase.icon className="w-6 h-6" />
              </div>
              <h3 className="font-semibold text-xl mb-2 text-sage-800">{useCase.title}</h3>
              <p className="text-sage-600">{useCase.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};